import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { SuiButton, SuiThemeProvider } from '@splashthat/sui';
import { Tooltip } from '@splashthat/doppler';
import suiTheme, { createSuiTheme } from '@splashthat/sui/lib/theme';
import { getCanUserCreateLibraryFormsUserPermission } from 'common/store/userPermissions/selectors';
import { getIsUserUsingRoleBasedPermissions } from 'common/store/userProperties/selectors';
import ConditionalWrap from 'common/hoc/ConditionalWrap';

import ScaledFormsSaveFormToLibraryModal from './ScaledFormsSaveFormToLibraryModal';
import { getFormId } from '../../selectors';
import { getIsFormSavedInLibrary } from '../../selectors/formLibrary';

const StyledButton = styled(SuiButton)`
    margin-right: 1rem;
`;

const theme = {
    components: {
        suiButton: {
            variants: {
                secondary: {
                    font: {
                        color: suiTheme.palette.grayscale.white,
                    },
                },
            },
        },
    },
};

export const ADD_TO_LIBRARY = 'Add to library';
export const ADDED_TO_LIBRARY = 'Added to the library';
export const DISABLED_MESSAGE =
    'Your role does not have permission to create new forms. If you believe this is a mistake, please reach out to your team administrator.';
const BASE_COMPONENT_NAME = 'ScaledFormsAddToLibraryButton';

const ScaledFormsAddToLibraryButton = () => {
    const formId = useSelector(getFormId);
    const isFormSavedInLibrary = useSelector((state) => getIsFormSavedInLibrary(state, formId));
    const isTeamManagerEnabled = useSelector(getIsUserUsingRoleBasedPermissions);
    const canUserAddToLibrary = useSelector(getCanUserCreateLibraryFormsUserPermission);
    const canCreate = isTeamManagerEnabled ? canUserAddToLibrary : true;

    const [open, setOpen] = useState(false);

    return (
        <React.Fragment>
            <SuiThemeProvider theme={createSuiTheme(theme)}>
                <ConditionalWrap
                    condition={!canCreate}
                    wrap={(children) => <Tooltip label={DISABLED_MESSAGE}>{children}</Tooltip>}
                >
                    <StyledButton
                        variation="secondary"
                        size="medium"
                        label={isFormSavedInLibrary ? ADDED_TO_LIBRARY : ADD_TO_LIBRARY}
                        onClick={() => setOpen(true)}
                        disabled={isFormSavedInLibrary || !canCreate}
                        data-qa={BASE_COMPONENT_NAME}
                    />
                </ConditionalWrap>
            </SuiThemeProvider>
            <ScaledFormsSaveFormToLibraryModal open={open} onClose={() => setOpen(false)} />
        </React.Fragment>
    );
};

export default ScaledFormsAddToLibraryButton;
